import React from 'react';
import HorizontalTabs from 'sushiweb/HorizontalTabs';
import { PolicyLevelTabs, TabsSectionWrapper, tabStyles } from '../constants';

const PolicyLevelSelector = ({ selectedLevel, handleTabClick }) => {
  return (
    <div className='tw-flex tw-items-center tw-border-solid !tw-border-x-0 !tw-border-t-0 tw-border-base-green tw-border-2 tw-p-0 tw-m-0'>
      <TabsSectionWrapper>
        <HorizontalTabs alignLinks={'left'}>
          {PolicyLevelTabs?.map((tab) => {
            if (!tab) return null;
            return (
              <React.Fragment key={tab.key}>
                <HorizontalTabs.Link
                  id={tab.key}
                  style={{
                    cursor: 'pointer',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '200px',
                  }}
                  active={selectedLevel === tab.key}
                  onClick={() => handleTabClick(tab.key)}
                  css={tabStyles}
                >
                  <div
                    className={`tw-font-medium ${
                      selectedLevel === tab.key
                        ? 'tw-text-base-green tw-text-[1.4rem]'
                        : ''
                    } `}
                  >
                    {tab.title}
                  </div>
                </HorizontalTabs.Link>
              </React.Fragment>
            );
          })}
        </HorizontalTabs>
      </TabsSectionWrapper>
    </div>
  );
};

export default PolicyLevelSelector;
